<template>
    <div>
        <v-container>
            <v-layout align-center justify-center>
                <v-flex xs12 sm12 md12 lg12 xl12 style="text-align: center;">
                    <v-card class="elevation-1 pa-3">
                        <v-card-text style="text-align: center">
                            <h3>{{$t("lang.exercise.quizQuestion")}}</h3>
                            <v-form ref="form" @keyup.enter.native="onSave">
                                <v-layout>
                                    <v-flex>
                                        <v-text-field append-icon="group" v-validate="'required'"
                                                      :label="$t('lang.exercise.name')"
                                                      v-model="exercise.name"
                                                      maxlength="200"
                                                      :data-vv-as="$t('lang.exercise.name')"
                                                      name="name"
                                                      :error-messages="errors.first('name')"
                                        />
                                    </v-flex>
                                </v-layout>
                                <v-layout>
                                    <v-flex>
                                        <v-text-field append-icon="code" v-validate="'required'"
                                                      :label="$t('lang.exercise.subject')"
                                                      v-model="exercise.subject"
                                                      maxlength="200"
                                                      :data-vv-as="$t('lang.exercise.subject')"
                                                      name="subject"
                                                      :error-messages="errors.first('subject')"/>

                                    </v-flex>
                                </v-layout>
                                <v-layout>
                                    <v-flex xs12 sm6 md6 lg6 xl6 style="margin-right: 5px">
                                        <i-datepicker :label="$t('lang.exercise.effectiveDate')"
                                                      v-validate="'required|date_format:yyyy-MM-dd'"
                                                      :data-vv-as="$t('lang.exercise.effectiveDate')"
                                                      name="effectiveDate"
                                                      ref="effectiveDate"
                                                      v-model="exercise.effectiveDate"
                                                      :error-messages="errors.first('effectiveDate')"
                                        />
                                    </v-flex>
                                    <v-flex xs12 sm6 md6 lg6 xl6 style="margin-left: 5px">
                                        <i-datepicker :label="$t('lang.exercise.dueDate')"
                                                      v-model="exercise.dueDate"
                                                      v-validate="'required|date_format:yyyy-MM-dd|after:effectiveDate,true'"
                                                      :data-vv-as="$t('lang.exercise.dueDate')"
                                                      name="dueDate"
                                                      :error-messages="errors.first('dueDate')"
                                        />
                                    </v-flex>
                                </v-layout>
                                <v-layout>
                                    <v-flex xs12 sm6 md6 lg6 xl6 style="margin-right: 5px">
                                        <v-text-field append-icon="access_time" v-validate="'required|numeric'"
                                                      :label="$t('lang.exercise.questionTime')"
                                                      :data-vv-as="$t('lang.exercise.questionTime')"
                                                      maxlength="4"
                                                      v-model="exercise.questionTime"
                                                      name="questionTime"
                                                      :error-messages="errors.first('questionTime')"
                                        />
                                    </v-flex>
                                    <v-flex xs12 sm6 md6 lg6 xl6 style="margin-left: 5px">
                                        <v-text-field
                                                :label="$t('lang.exercise.numberOfQuiz')"
                                                v-validate="'required|numeric|max_value:200|min_value:1'"
                                                maxlength="3"
                                                :data-vv-as="$t('lang.exercise.numberOfQuiz')"
                                                v-model="numberOfQuiz"
                                                name="numberOfQuiz"
                                                :error-messages="errors.first('numberOfQuiz')"
                                        />
                                    </v-flex>
                                </v-layout>
                                <v-layout>
                                    <v-flex xs12 sm6 md6 lg6 xl6>
                                        <v-text-field append-icon="code" v-validate="'required|numeric'"
                                                      :label="$t('lang.exercise.markScale')"
                                                      maxlength="4"
                                                      height="40px"
                                                      v-model="exercise.markScale"
                                                      :data-vv-as="$t('lang.exercise.markScale')"
                                                      name="markScale"
                                                      :error-messages="errors.first('markScale')"/>
                                    </v-flex>
                                    <v-flex xs12 sm6 md6 lg6 xl6 style="margin-left: 5px">
                                        <v-select append-icon="supervised_user_circle"
                                                  :label="$t('lang.exercise.receivers')"
                                                  height="40px"
                                                  :items="classMember"
                                                  item-text="fullName"
                                                  item-value="userId"
                                                  multiple
                                                  chips
                                                  v-model="receivers"
                                                  :data-vv-as="$t('lang.exercise.receivers')"
                                                  name="receivers"
                                                  :error-messages="errors.first('receivers')"/>
                                    </v-flex>
                                </v-layout>
                                <v-layout>
                                    <v-flex
                                            xs12
                                            sm12
                                            md8
                                            lg8
                                            xl8
                                            style="border:1px solid gray; border-radius:5px;margin:2px;padding:10px;max-height: 800px;overflow: scroll"
                                    >
                                        <file-view
                                                :editable="true"
                                                accept=".pdf, image/*"
                                                :attachId="exercise.attachId"
                                                :attachType="exercise.attachType"
                                                @change="uploadNewFile"
                                        />
                                    </v-flex>
                                    <v-flex
                                            xs12
                                            sm12
                                            md4
                                            lg4
                                            xl4
                                            style="border:1px solid gray; border-radius:5px;margin:2px;padding:10px"
                                    >
                                        <a
                                                class="quizQuestion"
                                                :id="'anchor'+(item-1)"
                                                :href="'#question'+(item-1)"
                                                v-for="item in parseInt(exercise.numberOfQuiz)"
                                        >{{item}}</a>

                                        <div
                                                class="answerDetail"
                                                :id="'question'+(item-1)"
                                                v-for="item in parseInt(exercise.numberOfQuiz)"
                                                :key="item"
                                        >
                                            <div class="answerHeader">Câu {{ item}}</div>

                                            <!--                                       <v-text-field
                                                                                           flat
                                                                                           v-validate="'required'"
                                                                                           :label="$t('lang.exercise.answer')+ ' câu '+item"
                                                                                           v-model="childExercise[item-1].answer"
                                                                                   />-->
                                            <v-autocomplete
                                                    :label="$t('lang.exercise.answer')+ ' câu '+item"
                                                    v-validate.initial="'required'"
                                                    v-model="childExercise[item-1].answer"
                                                    :data-vv-as="$t('lang.exercise.answer')"
                                                    :name="'answer_'+item"
                                                    :error-messages="errors.first('answer_'+item)"
                                                    :items="answerOptions"
                                            />
                                            <v-text-field
                                                    flat
                                                    v-validate.initial="'required'"
                                                    :label="$t('lang.exercise.subject')+ ' câu '+item"
                                                    :data-vv-as="$t('lang.exercise.subject')"
                                                    :name="'subject_'+item"
                                                    :error-messages="errors.first('subject_'+item)"
                                                    v-model="childExercise[item-1].subjects"
                                            />
                                            <v-autocomplete
                                                    :label="$t('lang.exercise.hardLevel')+ ' câu '+item"
                                                    v-model="childExercise[item-1].hardLevel"
                                                    :name="'hardLevel_'+item"
                                                    :items="hardLevelItems"
                                            />
                                        </div>
                                    </v-flex>
                                </v-layout>
                            </v-form>
                        </v-card-text>
                        <v-card-actions style="align-items:flex-end">
                            <div style="text-align:left">
                                <a href="/template/answer.xlsx">File template đáp án</a>
                                <i-upload
                                        :label="$t('lang.exercise.answerFile')"
                                        accept=".xlsx"
                                        input-type="button"
                                        name="uploadAnswer"
                                        :display-result="false"
                                        v-model="uploadAnswer"
                                />
                            </div>
                            <v-btn @click="fromLibary" style="margin-left:10px">
                                <v-icon dark left>library_add</v-icon>
                                {{ $t('lang.exercise.fromLibrary') }}
                            </v-btn>
                            <v-btn @click="fromWareHouse" style="margin-left:10px">
                                <v-icon dark left>storefront</v-icon>
                                {{ $t('lang.exercise.fromWarehouse') }}
                            </v-btn>
                            <v-btn @click="fromBankQuestion" style="margin-left:10px">
                                <v-icon dark left>account_balance</v-icon>
                                {{ $t('lang.exercise.questionBank') }}
                            </v-btn>
                        </v-card-actions>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="error" @click="cancel">
                                <v-icon dark left>cancel</v-icon>
                                {{ $t('lang.common.cancel') }}
                            </v-btn>
                            <v-btn class="yoprimary" dark @click="onSave">
                                <v-icon dark left>save</v-icon>
                                {{$t('lang.common.save')}}
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
        <library-question v-model="showLibrary" exercise-type="6" @onSelect="selectQuestionFromLibrary"/>
    </div>
</template>

<script>
    import {message} from "../../services";
    import IDatepicker from "../../components/form/DatePicker";
    import axios from "axios";
    import IUpload from "../../components/form/Upload";
    import pdf from "vue-pdf";
    import FileView from "./fileView";
    import LibraryQuestion from "./libraryQuestion";

    export default {
        name: "question-in-bank",
        components: {
            LibraryQuestion,
            pdf,
            IUpload,
            IDatepicker,
            FileView
        },

        props: {
            classId: {
                type: String | Number,
                default: () => {
                    return null;
                }
            },

            question: {
                type: Object,
                default: () => {
                    return null;
                }
            }
        },
        data() {
            return {
                uploadAnswer: null,
                receivers:[],
                clazz: {},
                classMember:[],
                hardLevelItems: [1, 2, 3, 4, 5],
                answerOptions: ['A', 'B', 'C', 'D'],
                accept: ".pdf, image/*",
                numberOfQuiz: 0,
                fileName: "",
                numPages: 0,
                currentPage: 1,
                attachPath: "",
                fileType: "",
                childExercise: [],
                exercise: {
                    name: "",
                    subject: "",
                    question: null,
                    dueDate: new Date(),
                    effectiveDate: new Date(),
                    questionTime: 30,
                    markScale: 10,
                    content: "",
                    numberOfQuiz: 0,
                    attachId: null,
                    attachType: null
                },
                showLibrary: false,
                subjects: [],
                grades: []
            };
        },

        watch: {
            numberOfQuiz: function (data) {
                if (isNaN(data)) {
                    this.exercise.numberOfQuiz = 0;
                    this.childExercise = [];
                    return;
                }
                this.exercise.numberOfQuiz = data;
                if (this.childExercise.length == data) {
                    console.log(this.childExercise);
                    return;
                } else if (this.childExercise.length > data) {
                    this.childExercise.length = data;
                    console.log(this.childExercise);
                } else {
                    let pushL = this.numberOfQuiz - this.childExercise.length;
                    for (let i = 0; i < pushL; i++) {
                        let q = {
                            answer: "",
                            subject: "",
                            hardLevel: 1
                        };
                        this.childExercise.push(q);
                    }
                }
                console.log(this.childExercise);
            },

            uploadAnswer: function (data) {
                axios
                    .post(
                        process.env.VUE_APP_API_URL +
                        "/exercise/uploadFileAnswer?attachId=" +
                        data
                    )
                    .then(
                        data => {
                            if (data == null || data.status == 500 ||data.length == 0) {
                                message.error("data is null or can't parse file");
                            } else {
                                this.numberOfQuiz = data.length;
                                this.childExercise = data;
                                message.success("Đã upload file đáp án thành công");
                                this.$refs.form.validate();
                            }
                        },
                        error => {
                            console.log(error);
                            message.error("Không thể xử lý file, hãy kiểm tra lại định dạng, nội dung file");

                        }
                    );
            }
        },

        created() {
            console.log(this.question);
            axios.post(process.env.VUE_APP_API_URL+"/class/getStudentOfClass?classId="+this.classId).then(
                data=>{
                    this.classMember = data;
                },
                error=>{
                    console.log(error);
                }
            )
            if (this.question != null) {
                this.initFromQuestion(this.question);
            } else {
                this.exercise.questionId = null;
                this.exercise.name = "";
                this.exercise.subject = "";
                this.exercise.questionTime = 90;
                this.numberOfQuiz = 0;
                this.exercise.dueDate = null;
                this.exercise.effectiveDate = null;
                this.exercise.markScale = 10;
                this.exercise.question = null;
                this.exercise.attachId = null;
                this.exercise.attachType = null;
                this.childExercise = [];
                //this.viewFile(null);
            }
        },

        computed: {},

        methods: {
            initFromQuestion:function(question){
                this.exercise.questionId = question.questionId;
                this.exercise.name = question.name;
                this.exercise.subject = question.subject;
                this.exercise.questionTime = question.questionTime;
                this.numberOfQuiz = question.numberOfQuiz;
                if(question.receivers != null &&  question.receivers != ""){
                    let arr = question.receivers.split(",");
                    this.receivers =[];
                    for(let i = 0;i<arr.length;i++){
                        if(!isNaN(arr[i])) {
                            this.receivers.push(parseInt(arr[i]));
                        }
                    }
                }
                this.exercise.dueDate = question.dueDate;
                this.exercise.effectiveDate = question.effectiveDate;
                this.exercise.markScale = question.markScale;
                this.exercise.question = question.question;
                this.exercise.attachId = question.attachId;
                this.exercise.attachType = question.attachType;
                this.childExercise = JSON.parse(question.question);
            },

            onSave() {
                this.$validator.validate().then(valid => {
                    console.log(valid);
                    if (!valid) {
                        message.error(this.$t("lang.common.validate_fail"));
                        return;
                    }
                    console.log(this.class);
                    this.exercise.question = JSON.stringify(this.childExercise);
                    if(this.receivers != null && this.receivers.length >0){
                        let ids =  this.receivers[0];
                        for(let i=1;i<this.receivers.length;i++){
                            ids +=","+this.receivers[i];
                        }
                        this.exercise. receivers = ids;
                    } else {
                        this.exercise.receivers = null;
                    }
                    axios
                        .post(
                            process.env.VUE_APP_API_URL +
                            "/exercise/saveQuiz?classId=" +
                            this.classId,
                            this.exercise
                        )
                        .then(
                            data => {
                                if (data.success) {
                                    message.success(this.$t("lang.common.save_success"));
                                    this.cancel();
                                    /*
                                                                        if (
                                                                            this.exercise.questionId != null &&
                                                                            this.exercise.questionId != undefined
                                                                        ) {
                                                                            this.onCancel();
                                                                        } else {
                                                                            this.exercise = {
                                                                                name: "",
                                                                                subject: "",
                                                                                dueDate: new Date(),
                                                                                effectiveDate: new Date(),
                                                                                markScale: 10,
                                                                                content: ""
                                                                            };
                                                                            this.numberOfQuiz = 0;
                                                                            this.numPages = 0;
                                                                            this.attachPath = "";
                                                                        }
                                    */
                                } else {
                                    message.error(this.$t(data.description));
                                }
                            },
                            error => {
                                console.log(error);
                            }
                        );
                });
            },

            fromLocal: function () {
                this.openFileDialog();
            },

            fromLibary: function () {
                this.showLibrary = true;
            },

            fromWareHouse: function(){

            },

            fromBankQuestion: function(){

            },

            selectQuestionFromLibrary: function (libQuestion) {
                libQuestion.questionId = null;
                this.initFromQuestion(libQuestion);
            },

            cancel: function () {
                this.$emit("onCancelCreate");
            },

            viewFile: function (attachId) {
                if (attachId == undefined || attachId == null) {
                    this.attachPath = null;
                    return;
                }
                this.attachPath = pdf.createLoadingTask(
                    process.env.VUE_APP_API_URL + "/download/attach/" + attachId
                );
                console.log("--- attach path ---");
                console.log(this.attachPath);
                this.attachPath.then(pdf => {
                    this.currentPage = 1;
                    this.numPages = pdf.numPages;
                    console.log("--- numpages ---");
                    console.log(this.numPages);
                });
            },

            uploadNewFile: function (data) {
                this.exercise.attachId = data.id;
                this.exercise.attachType = data.type;
            }
        }
    };
</script>

